import * as React from 'react'
import { Link } from 'react-router-dom'
import Button, { ButtonProps } from '@material-ui/core/Button'
import { LocationDescriptor } from 'history'

interface YumButtonProps extends Omit<ButtonProps, 'color'> {
  to?: LocationDescriptor
  color?: 'inherit' | 'primary' | 'secondary' | 'default'
}

const YumButton = ({ to, ...props }: YumButtonProps) => {
  return (
    <Button
      size="large"
      variant="contained"
      // @ts-ignore
      color="primary"
      disableElevation
      disableRipple
      // @ts-ignore: see https://github.com/mui-org/material-ui/issues/7877
      component={to ? Link : undefined}
      to={to}
      {...props}
    />
  )
}

export default YumButton
